<template>
    <div class="serial-form">
        <ol class="breadcrumb pull-right">
            <li>
                <router-link :to="{ path: '/' }">Home</router-link>
            </li>
            <li>
                <router-link :to="{ path: '/modul-pembelajaran-old' }"
                    >Modul Pembelajaran</router-link
                >
            </li>
            <li class="active">Create</li>
        </ol>

        <h1 class="page-header">Buat Modul Pembelajaran Baru</h1>

        <div class="row">
            <div class="col-md-12">
                <div class="panel panel-inverse">
                    <div class="panel-heading">
                        <h4 class="panel-title">Buat Modul Pembelajaran</h4>
                    </div>
                    <div class="panel-body">
                        <div
                            class="alert alert-danger fade in m-b-15"
                            v-if="errors.length > 0"
                        >
                            <span class="close" data-dismiss="alert"
                                >&times;</span
                            >
                            <strong>Terjadi kesalahan!</strong>
                            <ul>
                                <li
                                    v-for="(message, key) in errors"
                                    v-bind:key="key"
                                >
                                    {{ message }}
                                </li>
                            </ul>
                        </div>
                        <form
                            class="form-horizontal form-bordered"
                            @submit.prevent="onSubmit"
                        >
                            <div class="form-group">
                                <label class="col-md-2 control-label"
                                    >Nama Modul *</label
                                >
                                <div class="col-md-8 col-xs-12">
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Nama Modul Pembelajaran"
                                        required
                                        v-model="form.name"
                                    />
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-md-2 control-label"
                                    >Mata Pelajaran *</label
                                >
                                <div class="col-md-8 col-xs-12">
                                    <select
                                        class="form-control"
                                        v-model="form.subject"
                                    >
                                        <option
                                            value=""
                                            selected
                                            disabled
                                            hidden
                                        >
                                            Pilih Mapel
                                        </option>
                                        <option
                                            v-for="item in mapelList"
                                            v-bind:key="item.id"
                                            :value="item.id"
                                        >
                                            {{ item.nama }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-md-2 control-label"
                                    >Jenjang *</label
                                >
                                <div class="col-md-8 col-xs-12">
                                    <div class="radio">
                                        <label
                                            ><input
                                                @change="form.grades = []"
                                                type="radio"
                                                name="optradio"
                                                value="SD"
                                                v-model="form.level"
                                                checked
                                            />SD</label
                                        >
                                    </div>
                                    <div class="radio">
                                        <label
                                            ><input
                                                @change="form.grades = []"
                                                type="radio"
                                                name="optradio"
                                                value="SMP"
                                                v-model="form.level"
                                            />SMP</label
                                        >
                                    </div>
                                    <div class="radio">
                                        <label
                                            ><input
                                                @change="form.grades = []"
                                                type="radio"
                                                name="optradio"
                                                value="SMA"
                                                v-model="form.level"
                                            />SMA</label
                                        >
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-md-2 control-label"
                                    >Kelas *</label
                                >
                                <div class="col-md-2 col-xs-2">
                                    <v-row v-if="form.level === 'SD'">
                                        <span class="ml-5 mr-5">
                                            <input
                                                type="checkbox"
                                                value="1"
                                                v-model="form.grades"
                                            />
                                            &nbsp;1
                                        </span>
                                        <span class="mr-5">
                                            <input
                                                type="checkbox"
                                                value="2"
                                                v-model="form.grades"
                                            />
                                            &nbsp;2
                                        </span>
                                        <span class="mr-5">
                                            <input
                                                type="checkbox"
                                                value="3"
                                                v-model="form.grades"
                                            />
                                            &nbsp;3
                                        </span>
                                        <span class="mr-5">
                                            <input
                                                type="checkbox"
                                                value="4"
                                                v-model="form.grades"
                                            />
                                            &nbsp;4
                                        </span>
                                        <span class="mr-5">
                                            <input
                                                type="checkbox"
                                                value="5"
                                                v-model="form.grades"
                                            />
                                            &nbsp;5
                                        </span>
                                        <span class="mr-5">
                                            <input
                                                type="checkbox"
                                                value="6"
                                                v-model="form.grades"
                                            />
                                            &nbsp;6
                                        </span>
                                    </v-row>
                                    <v-row v-if="form.level === 'SMP'">
                                        <span class="ml-5 mr-5">
                                            <input
                                                type="checkbox"
                                                value="7"
                                                v-model="form.grades"
                                            />
                                            &nbsp;7
                                        </span>
                                        <span class="mr-5">
                                            <input
                                                type="checkbox"
                                                value="8"
                                                v-model="form.grades"
                                            />
                                            &nbsp;8
                                        </span>
                                        <span class="mr-5">
                                            <input
                                                type="checkbox"
                                                value="9"
                                                v-model="form.grades"
                                            />
                                            &nbsp;9
                                        </span>
                                    </v-row>
                                    <v-row v-if="form.level === 'SMA'">
                                        <span class="ml-5 mr-5">
                                            <input
                                                type="checkbox"
                                                value="10"
                                                v-model="form.grades"
                                            />
                                            &nbsp;10
                                        </span>
                                        <span class="mr-5">
                                            <input
                                                type="checkbox"
                                                value="11"
                                                v-model="form.grades"
                                            />&nbsp; 11
                                        </span>
                                        <span class="mr-5">
                                            <input
                                                type="checkbox"
                                                value="12"
                                                v-model="form.grades"
                                            />
                                            &nbsp;12
                                        </span>
                                    </v-row>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-md-2 control-label"
                                    >Semester</label
                                >
                                <div class="col-md-2 col-xs-2">
                                    <div>
                                        <select
                                            class="form-control"
                                            v-model="form.semester"
                                        >
                                            <option value="" selected>
                                                Pilih Semester
                                            </option>
                                            <option value="GANJIL">
                                                GANJIL
                                            </option>
                                            <option value="GENAP">GENAP</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-md-2 control-label"
                                    >Upload PDF *</label
                                >
                                <div class="col-md-4 col-xs-6">
                                    <!-- <input
                    type="file"
                    accept="application/pdf"
                    title=""
                    name="pdfName"
                    @change="onFileChange"
                  ><label id=""></label> -->
                                    <div class="row ml-2">
                                        <div class="column">
                                            <v-btn
                                                @click="$refs.uploader.click()"
                                                class="black60--text mb-4"
                                                width="154px"
                                                height="76px"
                                                elevation="0"
                                            >
                                                <div
                                                    style="
                                                        word-break: break-word !important;
                                                    "
                                                >
                                                    <v-icon size="30"
                                                        >mdi-cloud-upload</v-icon
                                                    >
                                                    <p>Upload File</p>
                                                </div>
                                            </v-btn>
                                            <input
                                                type="file"
                                                ref="uploader"
                                                class="d-none"
                                                accept="application/pdf"
                                                @change="onFileChange"
                                            />
                                        </div>

                                        <div
                                            v-if="$route.query.id"
                                            class="column ml-5"
                                        >
                                            <label>{{ fileName }}</label>
                                        </div>
                                        <div
                                            v-if="!$route.query.id"
                                            class="column"
                                        >
                                            <label>{{ fileName2 }}</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="form.url" class="form-group">
                                <label class="col-md-2 control-label"
                                    >View PDF</label
                                >

                                <!-- <span class="col-md-4 col-xs-2">{{ form.url }}</span> -->
                                <div class="pdf-container">
                                    <embed
                                        :src="form.url"
                                        type="application/pdf"
                                        width="100%"
                                        height="100%"
                                    />
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-md-2 control-label"
                                    >Password PDF</label
                                >
                                <div class="col-md-8 col-xs-12">
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="Password PDF"
                                        v-model="form.password"
                                    />
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-md-2 control-label"
                                    >Tidak Dimunculkan</label
                                >
                                <div class="col-md-2 col-xs-2">
                                    <div>
                                        <span>
                                            <input
                                                type="checkbox"
                                                name="TidakDimunculkan"
                                                v-model="form.status"
                                            />
                                            &nbsp; Tidak Dimunculkan
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <hr />
                            <div class="pull-right">
                                <button type="submit" class="btn btn-success">
                                    Simpan
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<script>
const Spinner = () => "@/modules/global/components/plugins/Spinner";

import Autocomplete from "@/modules/global/components/plugins/Autocomplete";
import AWS from "aws-sdk";
import getOssClient, {
    applyOssCredentials,
} from "@/modules/global/services/oss";
import ModulPembelajaranService from "@/modules/modul_belajar_old/services/modulpembelajaran.js";
import uniqid from "uniqid";

// You can upload file objects, Blob data, and OSS buffers to OSS.
// const data = '<File Object>';
// or const data = new Blob('content');
// or const data = new OSS.Buffer('content'));

export default {
    name: "ModulPembelajaranForm",

    components: {
        "app-autocomplete": Autocomplete,
        "app-spinner": Spinner,
    },

    data: function () {
        return {
            url: null,
            startDate: null,
            startTime: null,
            endTime: null,
            endDate: null,
            isLoading: false,
            filepdf: null,
            form: {
                grades: [],
                id: null,
                level: "",
                name: "",
                subject: "",
                url: "",
                semester: "",
                password: "",
                academic_year: "",
                week: "",
                filepdf: null,
                status: "",
            },
            pdfFile: null,
            itemUrl: "",
            errors: [],
            pdfName: null,
            fileName: "",
            fileName2: "",
            mapelList: JSON.parse(localStorage.getItem("mapels")),
        };
    },

    watch: {},

    computed: {
        gradeLevel() {
            switch (Number(this.form.level)) {
                case 0:
                    return [4, 5, 6];
                    break;
                case 1:
                    return [7, 8, 9];
                    break;
                case 2:
                    return [10, 11, 12];
                    break;
                default:
                    return [4, 5, 6];
                    break;
            }
        },
    },

    methods: {
        onFileChange(e) {
            const file = e.target.files[0];
            this.pdfFile = file;
            this.fileName2 = this.pdfFile.name;
            this.form.url = URL.createObjectURL(file);
        },

        async putObject() {
            var file = this.pdfFile;
            const context = this;
            context.isLoading = true;
            if (this.validateForm()) {
                var file = this.pdfFile;
                if (this.form.url && !file) {
                    this.filepdf = this.form.url;
                    this.save();
                } else {
                    if (!file) return;
                    try {
                        var filename = `${file.name
                            .split(".")
                            .slice(0, -1)
                            .join(".")}_${+new Date()}.${file.name.substring(
                            file.name.lastIndexOf(".") + 1,
                            file.name.length,
                        )}`;

                        const client = await getOssClient();

                        let result = await client.put(
                            `modules/${this.form.subject}/${filename}`,
                            file,
                        );

                        await client.putACL(
                            `modules/${this.form.subject}/${filename}`,
                            "public-read",
                        );

                        context.filepdf = result.url;
                        context.save();
                    } catch (error) {
                        alert("terjadi kesalahan : " + error);
                        context.isLoading = false;
                    }
                }
            } else this.isLoading = false;
        },

        async upload(e) {
            this.isLoading = true;
            if (this.validateForm()) {
                var file = this.pdfFile;
                if (this.form.url && !file) {
                    this.filepdf = this.form.url;
                    this.save();
                } else {
                    if (!file) return;

                    try {
                        await applyOssCredentials(AWS);
                    } catch (error) {
                        alert("terjadi kesalahan" + error.message);
                        this.isLoading = false;
                        return;
                    }

                    var spaceEndpoint = process.env.VUE_APP_OSS_END_POINT; // 'oss-ap-southeast-5.aliyuncs.com'
                    var bucket = new AWS.S3({
                        endpoint: spaceEndpoint,
                    });

                    var fileExt = file.name.substr(-4);
                    var filename = uniqid() + fileExt;
                    var params = {
                        Bucket: process.env.VUE_APP_OSS_BUCKET, // 'bonf-files',
                        Key:
                            "modules/" +
                            this.form.subject +
                            "/" +
                            file.name +
                            `_${+new Date()}`,
                        Body: file,
                        ContentType: file.type,
                        ACL: "public-read",
                    };

                    var context = this;
                    bucket.upload(params, function (error, data) {
                        if (error) {
                            alert("terjadi kesalahan" + error);
                            context.isLoading = false;
                        } else {
                            context.filepdf = data.Location;
                            context.save();
                        }
                    });
                }
            } else {
                this.isLoading = false;
            }
        },

        validateForm: function () {
            this.errors = [];
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

            if (
                this.form.name == "" ||
                this.form.name == " " ||
                this.form.name.trim() == ""
            )
                this.errors.push("Judul wajib diisi");

            if (this.form.subject == "")
                this.errors.push("Mata Pelajaran wajib diisi");

            if (!this.pdfFile && !this.form.url)
                this.errors.push("File PDF wajib di isi");

            this.isLoading = false;
            return this.errors.length == 0;
        },

        findmapel(data) {
            const found = this.mapelList.find((mapel) => mapel.nama == data);
            return found;
        },

        onSubmit() {
            this.isLoading = true;
            this.putObject();
        },

        save() {
            var context = this;
            if (this.validateForm()) {
                var data = {
                    name: this.form.name,
                    subject: this.form.subject,
                    url: this.filepdf,
                    level: this.form.level,
                    semester: this.form.semester,
                    grades: this.form.grades,
                    password: this.form.password,
                    status: !this.form.status ? "PUBLISHED" : "DRAFT",
                };

                if (this.$route.query.id) {
                    data.id = this.$route.query.id;

                    ModulPembelajaranService.editModulPembelajaran(
                        data,
                        function (response) {
                            if (response.success) {
                                if (
                                    response.data.description ==
                                    "Failed to Record Data"
                                ) {
                                    alert("gagal menyimpan data");
                                    context.isLoading = false;
                                } else {
                                    alert("Berhasil Menyimpan Data!");
                                    context.$router.push(
                                        "/modul-pembelajaran-old",
                                    );
                                    context.isLoading = false;
                                }
                            } else {
                                alert("gagal menyimpan data");
                                context.isLoading = false;
                            }
                        },
                    );
                } else {
                    ModulPembelajaranService.createModulPembelajaran(
                        data,
                        function (response) {
                            if (response.success) {
                                if (
                                    response.data.description ==
                                    "Failed to Record Data"
                                ) {
                                    alert("gagal menyimpan data");
                                    context.isLoading = false;
                                } else {
                                    alert("Berhasil Menyimpan Data!", data);
                                    context.$router.push(
                                        "/modul-pembelajaran-old",
                                    );
                                    context.isLoading = false;
                                }
                            } else {
                                context.isLoading = false;
                                alert("gagal menyimpan data", message);
                            }

                            context.$store.commit("reset_modul_pembelajaran");
                        },
                    );
                }
            } else {
                this.isLoading = false;
            }
        },
    },

    mounted: function () {
        var context = this;
        console.log(context.$store.state.modulpembelajaran);

        if (this.$route.query.id) {
            ModulPembelajaranService.getModulBelajar(
                this.$route.query.id,
                function (result) {
                    if (result.success) {
                        var ModulBelajar = result.data;
                        context.form = ModulBelajar;
                        let blob = new Blob([ModulBelajar.url], {
                            type: "application/pdf",
                        });

                        context.pdfName = new File([blob], ModulBelajar.url, {
                            type: "application/pdf",
                        });

                        context.fileName = context.form.url.slice(65);
                        context.form.level = ModulBelajar.jenjang;
                        context.form.status =
                            ModulBelajar.status === "PUBLISHED" ? false : true;
                    }
                    context.isLoading = false;
                },
            );
        }
    },
};
</script>

<style scoped>
#preview {
    display: flex;
    justify-content: center;
    align-items: center;
}

#preview img {
    max-width: 100%;
    max-height: 200px;
}

.pdf-container {
    /* display: flex; */
    justify-content: center;
    align-items: center;
    height: 100vh; /* Set the container height to 100% of the viewport height */
}
</style>



// WEBPACK FOOTER //
// Form.vue?824a33e6